import React from 'react';

interface OktaErrorProps {
  error?: Error;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function OktaError({ error }: OktaErrorProps) {
  if (error) {
    console.error('Failed to complete SSO Login, Okta Error: ', error);
  }

  return (
    <div className="login-loading-container">
      <div className="login-loading-content">
        <div className="login-loading-main-text">Sorry!</div>
        <div className="login-loading-sub-text">
          {
            (
              <div>
                <p>Your account is not yet enabled to access Online Game Store.</p>
                <p>If you think this is an error, please reach out to your local workplace experience team.</p>
              </div>
            )
          }
        </div>

      </div>
    </div >
  );
}

export default OktaError;
